import {
  Candidate,
  CandidateStatus,
  CareerTimelineType,
  City,
  Education,
  Experience,
  Role,
  RoleStatusCandidateCount,
  State,
  Questions,
} from "../../../Models";
import { useNavigate, useParams } from "react-router-dom";
import GradesChart from "./GradeCharts";
import { RoleStatusType, dateConverter, dateDiff } from "../../../Helpers";
import { CheckIcon, XMarkIcon } from "@heroicons/react/20/solid";
import {
  ArrowDownIcon,
  ArrowTopRightOnSquareIcon,
  DocumentDuplicateIcon,
  DocumentPlusIcon,
  DocumentTextIcon,
  FlagIcon
} from "@heroicons/react/24/outline";
import { CandidateAction } from "./RoleCandidates";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import TimelineModal from "../../Shared/TimelineModal";
import CandidateDetailModal from "./Candidatedetailsmodel";
import CVViewerModal from "../../Shared/CVViewerModal";
import useApiToken from "../../../hooks/useApiToken";
import RecruitmentTimelineModal from "../../Shared/RecruitmentTimelineModal/RecruitmentTimelineModal";
import CareerTimeline from "../../Candidates/CareerTimeline";
import Grade from "./Grade";
import ReAppliedModal from "./ReAppliedModal";
import { NIL } from "uuid";
import StraightTimeline from "../../Candidates/StraightTimerline";
import CandidateAssessmentResult from "../../Candidates/CandidateAssessmentResults";
import { OnBoardRankOrder } from "../../../helpers/constants";
import { GetRole, GetRoleStatus, GetRoleStatusById } from "../../../api/roles.api";
import { CandidateRoleAnswersBulkResponse } from "../../../api/assessmentquestion.api";
import {
  APPLICATION_CATEGORY_LABELS,
  APPLICATION_CATEGORY_STYLES,
  ApplicationCategory,
} from "../../../api/roleApplicationScoring.api";
import ApplicationScoreBreakdownModal from "./ApplicationScoreBreakdownModal";
import {
  GetCandidateStatus,
  GetCandidateTimeline,
  GetCandidateCvFlagResult,
  CandidateCvFlagResult
} from "../../../api/candidates.api";

function classNames(...classes: string[]): string {
  return classes.filter(Boolean).join(" ");
}

export default function RoleCandidatesList({
  candidates,
  selectedCandidate,
  handleSelectedCandidate,
  handleUpdateCandidates,
  status,
  colomns,
  agebased,
  expbased,
  setskillcol,
  skillcol,
  uniqueSkills,
  isShipping,
  roleListQuestions,
  candidateRoleAnswersBulk,
  showRoleQGrading = false,
}: {
  candidates: Candidate[];
  selectedCandidate: Candidate[];
  handleSelectedCandidate: (candidate: CandidateAction[]) => void;
  handleUpdateCandidates: (
    candidatesUpdate: CandidateStatus[],
    gradeStatusUpdate?: boolean
  ) => void;
  status: RoleStatusCandidateCount;
  colomns: number;
  agebased: boolean;
  expbased: boolean;
  setskillcol: React.Dispatch<React.SetStateAction<number>>;
  skillcol: number;
  uniqueSkills: string[];
  isShipping: boolean;
  roleListQuestions: Questions[];
  candidateRoleAnswersBulk: CandidateRoleAnswersBulkResponse;
  showRoleQGrading?: boolean;
}) {
  const [role, setRole] = useState<Role>();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenDetailExp, setIsOpenDetailExp] = useState<Experience[]>([]);
  const [clickedRow, setClickedRow] = useState<string>();
  const [timelineLoading, setTimelineLoading] = useState(false);
  const [timelineError, setTimelineError] = useState(false);
  const [timelineData, setTimelineData] = useState<CareerTimelineType | null>(
    null
  );

  const [reAppliedModalOpen, setReAppliedModalOpen] = useState(false);
  const [openTimeline, setOpenTimeline] = useState(false);
  const [hoveredCandidate, setHoveredCandidate] = useState<Candidate | null>(
    null
  );
  const [timelineData2, setTimelineData2] = useState<any[]>([]);
  const [candidateStatus, setCandidateStatus] = useState<any[]>([]);

  const [hoverdetails, sethoverdetails] = useState<any>();

  const timeoutIdRef = useRef<number | null>(null);
  // iPadOS Safari drops the click for a whole row when a synthesized mouseenter
  // mutates the DOM, so hover previews are gated to real mouse input.
  const pointerTypeRef = useRef<string>("mouse");
  // Where the last pointerdown landed in a row, to tell a tap apart from the
  // sideways scrolling this wide table needs (see isTouchTap).
  const pointerDownPosRef = useRef<{ x: number; y: number } | null>(null);
  // Set once touch navigated on pointerup, so a late click doesn't navigate twice.
  const touchNavigatedRef = useRef(false);
  // Touch/pen activation runs off pointerup, which Safari always dispatches.
  // Mouse returns false and keeps using the existing onClick handlers.
  const isTouchTap = (e: React.PointerEvent) => {
    if (e.pointerType === "mouse") return false;
    const down = pointerDownPosRef.current;
    pointerDownPosRef.current = null;
    // No pointerdown recorded, or the finger travelled - that was a scroll.
    return (
      !!down &&
      Math.abs(e.clientX - down.x) <= 10 &&
      Math.abs(e.clientY - down.y) <= 10
    );
  };
  const navigate = useNavigate();
  const token = useApiToken();
  const { roleId } = useParams();
  // Candidate whose Role Q Grading breakdown is open, if any.
  const [breakdownCandidate, setBreakdownCandidate] = useState<Candidate | null>(null);
  const [showResultCandidate, setShowResultCandidate] =
    useState<{ candidate: Candidate; roleStatusId: string } | null>(null);

  // CV Viewer state
  const [isCVViewerOpen, setIsCVViewerOpen] = useState(false);
  const [cvViewerCandidateIndex, setCvViewerCandidateIndex] = useState(0);

  // CV Flag expand state
  const [expandedCandidateId, setExpandedCandidateId] = useState<string | null>(
    null
  );


  const [isCVFlagModalOpen, setIsCVFlagModalOpen] = useState(false);
  const [cvFlagCandidate, setCvFlagCandidate] = useState<Candidate | null>(null);
  const [cvFlagData, setCvFlagData] = useState<CandidateCvFlagResult | null>(null);
  const [isFetchingCVFlags, setIsFetchingCVFlags] = useState(false);
  const [cvFlagError, setCVFlagError] = useState<string | null>(null);
  const cvFlagModalRef = useRef<HTMLDivElement | null>(null);


  useEffect(() => {
    if (!roleId || !token) return;
    GetRole(roleId, token).then((rl) => {
      setRole(rl);
    });
  }, [roleId, token]);

  useEffect(() => {
    if (!isCVFlagModalOpen) return;

    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as Node;
      if (cvFlagModalRef.current && !cvFlagModalRef.current.contains(target)) {
        setIsCVFlagModalOpen(false);
        setCvFlagCandidate(null);
        setCvFlagData(null);
        setCVFlagError(null);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isCVFlagModalOpen]);

  useEffect(() => {
    if (!role || !token || !openTimeline) return;
    setTimelineData2((prevState) => [
      ...prevState.map((item) => {
        if (Object.keys(item)[0] === "roleCreated") {
          return {
            roleCreated: {
              date: role?.date,
              color: "blue",
              radius: 50,
              text: "Job Posted",
            },
          };
        }
        return item;
      }),
    ]);

    if (hoveredCandidate) {
      GetCandidateStatus(hoveredCandidate.id, token).then((cs) => {
        const sortedStatuses = cs?.sort((a: any, b: any) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          if (dateA < dateB) {
            return -1;
          } else if (dateA > dateB) {
            return 1;
          }
          return a.roleStatus.order - b.roleStatus.order;
        });
        Promise.all(
          sortedStatuses
            ?.filter((s) => s.roleId === roleId)
            ?.map(async (status: CandidateStatus) => {
              try {
                const rs = await GetRoleStatusById(status.roleStatusId, token);
                return {
                  name: rs.name,
                  date: status.date,
                };
              } catch (error) {
                console.warn(`Failed to fetch role status ${status.roleStatusId}`, error);
                return null;
              }
            })
        ).then((si) => {
          const validStatuses = si.filter((s): s is { name: string; date: string } => s !== null);
          validStatuses?.unshift({
            name: "roleCreated",
            date: role.date,
          });
          setCandidateStatus(validStatuses);
        });
      });
    }
  }, [role, hoveredCandidate, token, openTimeline]);

  const containsSelectedCandidates = (sc: CandidateAction) => {
    for (var i = 0; i < selectedCandidate.length; i++) {
      if (selectedCandidate[i].id === sc.id) {
        return true;
      }
    }
    return false;
  };

  const getExperienceRanking = (exp: Experience) => {
    let ranking = 0;
    if (role?.rankTypeId === null) role.rankTypeId = NIL;
    exp.companyLocation.company.companyRankings?.forEach((cr) => {
      if (cr.rankTypeId === role?.rankTypeId)
        ranking = cr.rankCategory.rankNumber;
    });
    return ranking;
  };

  const getEducationRanking = (edu: Education) => {
    let ranking = 0;
    if (role?.rankTypeId === null) role.rankTypeId = NIL;
    edu.university.universityRankings?.forEach((ur) => {
      if (ur.rankTypeId === role?.rankTypeId)
        ranking = ur.rankCategory.rankNumber;
    });
    return ranking;
  };
  const getLastKnownPos = (candidate: Candidate) => {
    const lastExperience =
      candidate.experience[candidate.experience.length - 1];
    const lastEducation = candidate.education[candidate.education.length - 1];

    if (candidate.current === null) {
      if (candidate.experience.length !== 0 && lastExperience.relevant) {
        return {
          ranking: getExperienceRanking(lastExperience),
          type: "exp",
          value: lastExperience,
        };
      } else if (candidate.education.length !== 0) {
        return {
          ranking: getEducationRanking(lastEducation),
          type: "edu",
          value: lastEducation,
        };
      }
    } else if (candidate.current === "working") {
      return {
        ranking: getExperienceRanking(lastExperience),
        type: "exp",
        value: lastExperience,
      };
    } else if (candidate.current === "studying") {
      return {
        ranking: getEducationRanking(lastEducation),
        type: "edu",
        value: lastEducation,
      };
    }
  };

  const getLatestStatus = (latestStatusId: string) => {
    const latestStatus = status.roleStatuses.find(
      (rs) => rs.id === latestStatusId
    );
    if (latestStatus) return latestStatus;
  };

  const getColorClassByPercentile = (percentile: any) => {
    if (percentile > 0 && percentile <= 10) {
      return "bg-[#1E3F66]";
    } else if (percentile <= 25) {
      return "bg-[#2E5984]";
    } else if (percentile <= 50) {
      return "bg-[#528AAE]";
    } else if (percentile <= 75) {
      return "bg-[#73A5C6]";
    } else if (percentile <= 90) {
      return "bg-[#91BAD6]";
    } else {
      return "bg-[#BCD2E8]";
    }
  };

  const getColorClassBySkillScore = (percentile: any) => {
    if (percentile >= 0 && percentile <= 10) {
      return "bg-[#b37400] dark:text-gray-800";
    } else if (percentile > 10 && percentile <= 25) {
      return "bg-[#cc8400] dark:text-gray-800";
    } else if (percentile > 25 && percentile <= 50) {
      return "bg-[#e69500]";
    } else if (percentile > 50 && percentile <= 75) {
      return "bg-[#ffb933] dark:text-gray-800";
    } else if (percentile > 75 && percentile <= 90) {
      return "bg-[#ffd580] dark:text-gray-800";
    } else {
      return "bg-[#ffebc2] dark:text-gray-800";
    }
  };

  const handleTimelineClick = async (
    e: React.MouseEvent,
    candidate: Candidate
  ) => {
    e.preventDefault();
    setTimelineLoading(true);
    try {
      if (roleId !== undefined && token !== undefined) {
        const candidateTimeline = await GetCandidateTimeline(
          roleId,
          candidate.id,
          token
        );
        setTimelineData(candidateTimeline);
        setTimelineError(false);
        setTimelineLoading(false);
      }
    } catch (error) {
      console.error("Error fetching candidate timeline:", error);
      setTimelineError(true);
    }
    setIsModalOpen(true);
  };
  const onConfirmTimeline = () => {
    setOpenTimeline(false);
  };
  const showGrades = (candidate: Candidate) => {
    if (candidate.latestStatusId) {
      const isOfferedOrHired =
        getLatestStatus(candidate.latestStatusId)?.name ===
        RoleStatusType.hired ||
        getLatestStatus(candidate.latestStatusId)?.name ===
        RoleStatusType.rejected;

      return isOfferedOrHired
        ? candidate.candidateStatuses.length > 2
        : candidate.candidateStatuses.length > 1;
    } else return false;
  };

  const openCVViewer = (candidateIndex: number) => {
    setCvViewerCandidateIndex(candidateIndex);
    setIsCVViewerOpen(true);
  };

  const closeCVViewer = () => {
    setIsCVViewerOpen(false);
  };

  const handleRowClick = (candidate: Candidate) => {
    if (expandedCandidateId === candidate.id) {
      // Collapse if already expanded
      setExpandedCandidateId(null);
    } else {
      // Expand selected row details without mutating role-flag modal state
      setExpandedCandidateId(candidate.id);
    }
  };

  const handleRoleFlagClick = async (
    e: React.MouseEvent,
    candidate: Candidate
  ) => {
    e.preventDefault();
    e.stopPropagation();

    if (isCVFlagModalOpen && cvFlagCandidate?.id === candidate.id) {
      setIsCVFlagModalOpen(false);
      setCvFlagCandidate(null);
      setCvFlagData(null);
      setCVFlagError(null);
      return;
    }

    setCvFlagCandidate(candidate);
    setCvFlagData(null);
    setCVFlagError(null);
    setIsCVFlagModalOpen(true);

    if (!roleId || !token) {
      setCVFlagError("Role or token is missing.");
      return;
    }

    setIsFetchingCVFlags(true);
    try {
      const res = await GetCandidateCvFlagResult(roleId, candidate.id, token);
      setCvFlagData(res);
    } catch (error: any) {
      setCvFlagData(null);
      setCVFlagError(error?.message || "Failed to fetch CV flags");
    } finally {
      setIsFetchingCVFlags(false);
    }
  };

  const assessmentScoreStatuses = useMemo(
    () =>
      status.roleStatuses
        .filter((rs) => rs.assessmentTemplateId || rs.assessmentId)
        .sort((a, b) => a.order - b.order),
    [status.roleStatuses]
  );

  return (
    <>
      <tbody className="bg-white dark:bg-darkbg dark:divide-gray-600">
        {candidates.map((candidate, index) => (
          <Fragment key={candidate.id}>
            <tr
              className={`
            ${containsSelectedCandidates(candidate)
                  ? "bg-gray-50 dark:bg-[#1c2229]"
                  : ""
                } border-t cursor-pointer hover:bg-gray-50 dark:hover:bg-[#1c2229]`}
              onClick={() => {
                setIsOpenDetailExp(candidate.experience);
                setClickedRow((clickedRow || (role?.department !== "Shipping")) ? undefined : candidate.id);
                handleRowClick(candidate);
                // Open the candidate from anywhere in the row. Shipping is excluded
                // because there the row click toggles the sea-experience panel below.
                if (role?.department !== "Shipping") {
                  navigate(`/roles/${roleId}/candidates/${candidate.id}`);
                }
              }}
              onPointerEnter={(e) => {
                pointerTypeRef.current = e.pointerType;
              }}
              onPointerDown={(e) => {
                pointerDownPosRef.current = { x: e.clientX, y: e.clientY };
              }}
              onMouseEnter={(e) => {
                // Mouse only: on touch this state update is what made Safari
                // swallow the tap for the whole row (see pointerTypeRef).
                if (pointerTypeRef.current !== "mouse") return;
                setHoveredCandidate(candidate);
              }}
              onMouseLeave={(e) => {
                setHoveredCandidate(null);
              }}
            >
              {/* CheckBox */}
              <td
                className="relative px-7 sm:w-12 sm:px-6 cursor-default"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {containsSelectedCandidates(candidate) ? (
                  <div className="absolute inset-y-0 left-0 w-0.5 bg-indigo-600" />
                ) : (
                  <>
                    {candidate.latestStatusId &&
                      getLatestStatus(candidate.latestStatusId)?.name ===
                      RoleStatusType.hired && (
                        <div className="rounded-sm absolute left-4 top-1/2 -mt-2 h-4 w-4 flex justify-center items-center bg-green-600 z-10 text-white">
                          <CheckIcon />
                        </div>
                      )}
                    {candidate.latestStatusId &&
                      getLatestStatus(candidate.latestStatusId)?.name ===
                      RoleStatusType.rejected && (
                        <div className="rounded-sm absolute left-4 top-1/2 -mt-2 h-4 w-4 flex justify-center items-center bg-red-600 z-10 text-white">
                          {" "}
                          <XMarkIcon />
                        </div>
                      )}
                  </>
                )}

                <input
                  type="checkbox"
                  className={`z-[11] bg-transparent absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 `}
                  value={candidate.email}
                  checked={containsSelectedCandidates(candidate)}
                  onChange={(e) =>
                    handleSelectedCandidate(
                      e.target.checked
                        ? [...selectedCandidate, candidate]
                        : selectedCandidate.filter((p) => p !== candidate)
                    )
                  }
                />
              </td>
              {/* Name */}
              <td
                className={classNames(
                  "whitespace-nowrap text-sm font-medium pr-6",
                  containsSelectedCandidates(candidate)
                    ? "text-indigo-600"
                    : "text-gray-900 dark:text-gray-200"
                )}
              >
                <div className="relative flex items-center">
                  <a
                    href={`/roles/${roleId}/candidates/${candidate.id}`}
                    onClick={(e) => {
                      e.preventDefault()
                      // Touch already navigated on pointerup; ignore the late click
                      // so the same route isn't pushed onto history twice.
                      if (touchNavigatedRef.current) {
                        touchNavigatedRef.current = false;
                        return;
                      }
                      navigate(`/roles/${roleId}/candidates/${candidate.id}`);
                    }}
                    onPointerEnter={(e) => {
                      pointerTypeRef.current = e.pointerType;
                    }}
                    onPointerUp={(e) => {
                      if (!isTouchTap(e)) return;
                      e.preventDefault();
                      touchNavigatedRef.current = true;
                      navigate(`/roles/${roleId}/candidates/${candidate.id}`);
                    }}
                    onMouseEnter={(e) => {
                      if (pointerTypeRef.current !== "mouse") return;
                      timeoutIdRef.current = window.setTimeout(() => {
                        handleTimelineClick(e, candidate);
                      }, 500);
                    }}
                    onMouseLeave={(e) => {
                      if (timeoutIdRef.current) {
                        window.clearTimeout(timeoutIdRef.current);
                      }
                      setTimelineData(null);
                      setIsModalOpen(false);
                    }}
                    className="text-wrap"
                  >
                    {candidate.isCVDataMismatch ? <div className="text-[#E3085C] font-bold flex flex-row items-center gap-3" title={candidate.cvMismatchError || "CV Data Mismatched for this Candidate"}>
                      {candidate.firstName} {candidate.lastName}
                      <ArrowTopRightOnSquareIcon height={20} className="text-entntblue" onPointerUp={(e) => { e.stopPropagation(); }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate(`candidates/${candidate.id}/validateCV`) }} />
                    </div> : <div className="flex flex-row items-center gap-3">
                      {candidate.firstName} {candidate.lastName}
                      <ArrowTopRightOnSquareIcon height={20} className="text-entntblue" onPointerUp={(e) => { e.stopPropagation(); }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate(`candidates/${candidate.id}/validateCV`) }} />
                    </div>}
                    {timelineData?.candidateId === candidate.id && (
                      <TimelineModal
                        open={isModalOpen}
                        setOpen={setIsModalOpen}
                        content={timelineData}
                        loading={timelineLoading}
                        timelineError={timelineError}
                        timeline={
                          timelineData?.timeline.length <= 3 ? (
                            <StraightTimeline timeline={timelineData?.timeline} />
                          ) : (
                            <CareerTimeline
                              timeline={timelineData?.timeline || []}
                            />
                          )
                        }
                      />
                    )}
                  </a>
                  <div className="ml-2 relative">
                    {candidate.reApply && (
                      <span
                        className="text-red-600 font-bold"
                        onPointerEnter={(e) => {
                          pointerTypeRef.current = e.pointerType;
                        }}
                        onMouseEnter={(e) => {
                          if (pointerTypeRef.current !== "mouse") return;
                          timeoutIdRef.current = window.setTimeout(() => {
                            setReAppliedModalOpen(true);
                          }, 500);
                        }}
                        onMouseLeave={(e) => {
                          if (timeoutIdRef.current) {
                            window.clearTimeout(timeoutIdRef.current);
                          }
                          setReAppliedModalOpen(false);
                        }}
                      >
                        {candidate.reApply === candidate.email ? (
                          <DocumentPlusIcon className="h-5" />
                        ) : (
                          <DocumentDuplicateIcon className="h-5" />
                        )}
                      </span>
                    )}
                    {hoveredCandidate &&
                      hoveredCandidate.id === candidate.id &&
                      reAppliedModalOpen &&
                      candidate.reApply && (
                        <ReAppliedModal
                          reApply={candidate.reApply}
                          email={candidate.email}
                        />
                      )}
                  </div>
                  <div className="ml-2">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        openCVViewer(index);
                      }}
                      className="p-1 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 text-blue-600 hover:text-blue-800"
                      title="View CV"
                    >
                      <DocumentTextIcon className="h-4 w-4" />
                    </button>
                  </div>
                 
                </div>
              </td>
              {!isShipping && <td className="whitespace-nowrap truncate max-w-[80px]  pr-16 text-sm text-gray-500 dark:text-gray-300" title={candidate.cvMismatchError}>
                {candidate.cvMismatchError ?? "-"}
              </td>}
              {!isShipping && colomns === 2 && (
                <>
                  <td className="px-2 py-2">
                    <div className={`h-5 w-5 flex items-center justify-center rounded-md font-bold  ${candidate.isEducationDetailsMismatch ? ' text-red-600' : ' text-green-600'}`}>
                      {candidate.isEducationDetailsMismatch ? '✓' : '✕'}
                    </div>
                  </td>
                  <td className="px-2 py-2">
                    <div className={`h-5 w-5 flex items-center justify-center rounded-md font-bold   ${candidate.isEducationPeriodMismatch ? ' text-red-600' : ' text-green-600'}`}>
                      {candidate.isEducationPeriodMismatch ? '✓' : '✕'}
                    </div>
                  </td>
                  <td className="px-2 py-2">
                    <div className={`h-5 w-5 flex items-center justify-center rounded-md font-bold  ${candidate.isExperienceDetailsMismatch ? ' text-red-600' : ' text-green-600'}`}>
                      {candidate.isExperienceDetailsMismatch ? '✓' : '✕'}
                    </div>
                  </td>
                  <td className="px-2 py-2">
                    <div className={`h-5 w-5 flex items-center justify-center rounded-md font-bold  ${candidate.isExperiencePeriodMismatch ? ' text-red-600' : ' text-green-600'}`}>
                      {candidate.isExperiencePeriodMismatch ? '✓' : '✕'}
                    </div>
                  </td>
                </>
              )}
              {/* Location */}
              <td className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                <div className="flex">
                  <span
                    className={`${candidate.workLocation2City ? "max-w-20 truncate" : ""
                      }`}
                    title={
                      candidate.workLocation1City.name +
                      (candidate.workLocation2City
                        ? ", " + candidate.workLocation2City.name
                        : "")
                    }
                  >
                    {candidate.workLocation1City.name}
                  </span>
                </div>
              </td>
              {/* Department */}
              {/* <td className={"whitespace-nowrap text-sm text-gray-500 dark:text-gray-300 " + (!(role?.department === "Shipping") && 'hidden')}>
                <div className="flex">
                  <span
                    className={`${candidate.shippingDepartment ? "truncate" : ""
                      }`}
                    title={
                      [...Array.from(new Set(candidate.shippingDepartment))].join(", ")
                    }
                  >
                    {[...Array.from(new Set(candidate.shippingDepartment))].join(", ") || "Shipping"}
                  </span>
                </div>
              </td> */}
              {/* Rank */}
              {/* <td className={"whitespace-nowrap text-sm text-gray-500 dark:text-gray-300 " + (!(role?.department === "Shipping") && 'hidden')}>
                <div className="flex group">
                  <span
                    className={"truncate"}
                    title={
                      candidate.experience.sort((a, b) => (OnBoardRankOrder(a) > OnBoardRankOrder(b) ? 1 : -1))[0]?.rank ?? ""
                    }
                  >
                    {candidate.experience.sort((a, b) => (OnBoardRankOrder(a) > OnBoardRankOrder(b) ? 1 : -1))[0]?.rank ?? ""}
                  </span>
                  <div className="relative">
                    <div className="z-10 absolute rounded-md shadow-md -bottom-2 p-2 bg-white dark:bg-darkbglight hidden group-hover:block">
                      {candidate.experience.sort((a, b) => (a.startDate > b.startDate ? 1 : -1)).map((e) => {
                        return (
                          <>
                            {
                              e.isOnboard && <><span className="px-1 py-2 text-xs">{e?.rank} - {Math.floor(dateDiff(e.startDate, e.endDate) / 12)} yrs and {(dateDiff(e.startDate, e.endDate) % 12)} months </span><br /></>
                            }
                          </>
                        )
                      })}
                    </div>
                  </div>

                </div>
              </td> */}
              {/* Age */}
              <td
                className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300"
                onPointerEnter={(e) => {
                  pointerTypeRef.current = e.pointerType;
                }}
                onMouseEnter={(e) => {
                  if (pointerTypeRef.current !== "mouse") return;
                  timeoutIdRef.current = window.setTimeout(() => {
                    setOpenTimeline(true);
                  }, 500);
                }}
                onMouseLeave={(e) => {
                  if (timeoutIdRef.current) {
                    window.clearTimeout(timeoutIdRef.current);
                  }
                  setOpenTimeline(false);
                }}
              >
                <span
                  className={`relative items-center justify-center h-11 w-11  inline-flex p-2 text-white text-xs font-bold rounded-full ${getColorClassByPercentile(candidate.agePercentile)}`}
                >
                  {candidate.age > 100 ? "-" : Math.floor(candidate.age)}
                  {hoveredCandidate &&
                    openTimeline &&
                    hoveredCandidate.id === candidate.id && (
                      <RecruitmentTimelineModal
                        openTimeline={openTimeline}
                        setOpenTimeline={setOpenTimeline}
                        onConfirmTimeline={onConfirmTimeline}
                        title=""
                        description=""
                        timelineData={timelineData2}
                        role={role}
                        status={status}
                        candidateStatus={candidateStatus}
                        hoveredCandidate={hoveredCandidate}
                      />
                    )}
                </span>
              </td>
              {/* Experience */}
              {/* <td className="whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                <div
                  className={`flex items-center justify-center h-12 w-12 rounded-full border border-white ${getColorClassByPercentile(candidate.expPercentileforsameage)}`}
                >
                  <div
                    className={`flex items-center justify-center h-8 w-8 text-xs font-bold rounded-full border border-white 
                  ${candidate.experiencePercentileMonths < 25 ? "text-gray-500" : "text-gray-300"} 
                  ${getColorClassByPercentile(100-candidate.experiencePercentileMonths)}`}
                  >
                    {candidate.experienceInMonths}
                  </div>
                </div>
              </td> */}
              {/* OboardExperience */}
              {/* <td className={"whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 px-4 " + (!(role?.department === "Shipping") && 'hidden')}>
                <div
                  className={`flex items-center justify-center h-12 w-12 rounded-full border border-white ${getColorClassByPercentile(candidate.expPercentileforsameage)}`}
                >
                  <div
                    className={`flex items-center justify-center h-8 w-8 text-xs font-bold rounded-full border border-white 
                  ${candidate.onBoardExperiencePercentileMonths < 25 ? "text-gray-500" : "text-gray-300"} 
                  ${getColorClassByPercentile(100-candidate.onBoardExperiencePercentileMonths)}`}
                  >
                    {candidate.onBoardExperienceInMonths}
                  </div>
                </div>
              </td> */}
              {/* CvGrade */}
              {!isShipping && <td className=" whitespace-nowrap text-sm text-gray-500 dark:text-gray-300 px-4">
                <div className="text-sm text-gray-700 dark:text-gray-300">
                  <div
                    className={`${expbased
                      ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(100 - candidate.combinePercentileBasedEXP)}`
                      : ""
                      }`}
                  >
                    <div
                      className={`${agebased
                        ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(100 - candidate.combinedPercentileBasedAge)}`
                        : ""
                        }`}
                    >
                      <span
                        className={`flex items-center justify-center h-8 w-8 text-white text-xs font-bold rounded-full border border-white ${getColorClassByPercentile(100 - candidate.combinedGradePercentile)}`}
                        onMouseEnter={() => sethoverdetails(candidate)}
                        onMouseLeave={() => sethoverdetails(null)}
                      >
                        {candidate.combinedGrade && candidate.combinedGrade.toFixed(1)}
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  {hoverdetails && hoverdetails.id === candidate.id && (
                    <CandidateDetailModal
                      isOpen={true}
                      candidate={hoverdetails}
                      isShipping={(role?.department === "Shipping")}
                    />
                  )}
                </div>
              </td>}
              {(colomns === 1) && (
                <>
                  <td className=" whitespace-nowrap text-sm text-gray-500 dark:text-gray-300 px-4">
                    <div
                      className={`${expbased
                        ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(100 - candidate.educationPercentileBasedEXP)}`
                        : ""
                        }`}
                    >
                      <div
                        className={`${agebased
                          ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(100 - candidate.educationPercentileBasedAge)}`
                          : ""
                          }`}
                      >
                        <div className="">
                          <span
                            className={`flex items-center justify-center h-8 w-8 text-white text-xs font-bold rounded-full border border-gray-200 ${getColorClassByPercentile(100 - candidate.educationPercentileSameRole)}`}
                          >
                            {candidate.totalEducationGrade && candidate.totalEducationGrade.toFixed(1)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className={"whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 px-4 " + (!(role?.department === "Shipping") && 'hidden')}>
                    <div
                      className={`${expbased
                        ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(candidate.maritimeEducationPercentileBasedEXP)}`
                        : ""
                        }`}
                    >
                      <div
                        className={`${agebased
                          ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(candidate.maritimeAcademyEducationPercentileBasedAge)}`
                          : ""
                          }`}
                      >
                        <div className="">
                          <span
                            className={`flex items-center justify-center h-8 w-8 text-white text-xs font-bold rounded-full border border-gray-200 ${getColorClassByPercentile(candidate.maritimeAcademyEducationPercentileSameRole)}`}
                          >
                            {candidate.totalMaritimeAcademyEducationGrade && candidate.totalMaritimeAcademyEducationGrade.toFixed(1)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </>
              )}

              {colomns === 1 && (
                <>
                  <td className=" whitespace-nowrap text-sm text-gray-500 dark:text-gray-300 px-4">
                    <div
                      className={`${expbased
                        ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(100 - candidate.experiencePercentileBasedEXP)}`
                        : ""
                        }`}
                    >
                      <div
                        className={`${agebased
                          ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(100 - candidate.experiencePercentileBasedAge)}`
                          : ""
                          }`}
                      >
                        <div className="">
                          <span
                            className={`flex items-center justify-center h-8 w-8 text-white text-xs font-bold rounded-full border border-gray-200 ${getColorClassByPercentile(100 - candidate.experiencePercentileSameRole)}`}
                          >
                            {candidate.totalExperienceGrade && candidate.totalExperienceGrade.toFixed(1)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className={"whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 px-4 " + (!(role?.department === "Shipping") && 'hidden')}>
                    <div
                      className={`${expbased
                        ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(candidate.onBoardExperiencePercentileBasedEXP)}`
                        : ""
                        }`}
                    >
                      <div
                        className={`${agebased
                          ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(candidate.onBoardExperiencePercentileBasedAge)}`
                          : ""
                          }`}
                      >
                        <div className="">
                          <span
                            className={`flex items-center justify-center h-8 w-8 text-white text-xs font-bold rounded-full border border-gray-200 ${getColorClassByPercentile(candidate.onBoardExperiencePercentileSameRole)}`}
                          >
                            {candidate.totalOnBoardExperienceGrade && candidate.totalOnBoardExperienceGrade.toFixed(1)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </>
              )}

              {colomns === 1 && (
                <td className={"text-sm text-gray-700 dark:text-gray-300 " + (role?.department === "Shipping" && 'hidden')}>
                  <div
                    className={`${expbased
                      ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200 ${getColorClassByPercentile(candidate.gapPercentileBasedEXP)}`
                      : ""
                      }`}
                  >
                    <div
                      className={`${agebased
                        ? `flex items-center justify-center h-12 w-12 rounded-full border border-gray-200  ${getColorClassByPercentile(candidate.gapmonthspercentileAge)}`
                        : ""
                        }`}
                    >
                      <div
                        className={`flex items-center justify-center h-8 w-8 text-white text-xs font-bold rounded-full border border-white ${getColorClassByPercentile(candidate.gappercentile)}`}
                      >
                        {candidate.totalGapMonths}
                      </div>
                    </div>
                  </div>
                </td>
              )}

              {/* Graph */}
              {colomns === 1 && (
                <td className={"whitespace-nowrap  dark:text-gray-300 flex items-center justify-center h-11 w-11  text-white text-xs font-bold rounded-full border-2 border-black my-[18px] " + (role?.department === "Shipping" && 'hidden')}>
                  <GradesChart
                    educationGrades={candidate.educationGrades}
                    experienceGrades={candidate.experienceGrades}
                  />
                </td>
              )}

              <td className="relative whitespace-nowrap text-sm text-gray-500 dark:text-gray-300 px-4 cursor-pointer" onClick={(e) => handleRoleFlagClick(e, candidate)}>
                {
                  candidate.cvTier === "Tier 1" ? (
                    <span className="bg-green-500 text-white px-2 py-1 rounded-full text-xs font-bold">
                      {candidate.cvScore}
                    </span>
                  ) : candidate.cvTier === "Tier 2" ? (
                    <span className="bg-yellow-500 text-white px-2 py-1 rounded-full text-xs font-bold">
                      {candidate.cvScore}
                    </span>
                  ) : candidate.cvTier === "Tier 3" ? (
                    <span className="bg-red-500 text-white px-2 py-1 rounded-full text-xs font-bold">
                      {candidate.cvScore}
                    </span>
                  ) : (<span className="text-xs font-bold">N/A</span>)

                  
                }
                {isCVFlagModalOpen && cvFlagCandidate?.id === candidate.id && (
                      <div
                        ref={cvFlagModalRef}
                        className="absolute top-6 left-0 z-20 w-[360px] max-h-[60vh] text-wrap rounded-lg border border-gray-300 bg-white p-3 shadow-lg dark:border-gray-600 dark:bg-darkbglight"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <div className="mb-2 flex items-center justify-between">
                          <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                            Role Flags
                          </h4>
                          <button
                            className="rounded px-2 py-1 text-xs text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setIsCVFlagModalOpen(false);
                              setCvFlagCandidate(null);
                            }}
                          >
                            Close
                          </button>
                        </div>

                        {isFetchingCVFlags && (
                          <p className="text-xs text-gray-500 dark:text-gray-300">Loading role flags...</p>
                        )}

                        {cvFlagError && (
                          <p className="text-xs text-red-500">{cvFlagError}</p>
                        )}

                        {!isFetchingCVFlags && !cvFlagError && cvFlagData?.summary && (
                          <div className="mb-3 rounded border border-gray-200 bg-gray-50 p-2 text-xs text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200">
                            {cvFlagData.summary}
                          </div>
                        )}

                        {!isFetchingCVFlags && !cvFlagError && cvFlagData?.flags?.length ? (
                          <div className="space-y-2">
                            {cvFlagData.flags.map((flag, idx) => (
                              <div key={`${flag.flag_title}-${idx}`} className="rounded border-l-4 border-orange-400 bg-gray-50 p-2 dark:bg-gray-800">
                                <p className="text-xs font-medium text-gray-900 dark:text-gray-100">{flag.flag_title}</p>
                                <p className="text-xs text-gray-600 dark:text-gray-300">{flag.reason}</p>
                              </div>
                            ))}
                          </div>
                        ) : null}

                        {!isFetchingCVFlags && !cvFlagError && !cvFlagData?.summary && !cvFlagData?.flags?.length && (
                          <p className="text-xs text-gray-500 dark:text-gray-300">No role flags found for this candidate.</p>
                        )}
                      </div>
                    )}
              </td>

              {assessmentScoreStatuses.map((rs) => {
                const assessmentScore = candidate.assessmentScores?.find(
                  (a) => a.roleStatusId === rs.id
                );
                return (
                  <td
                    key={`assessment-${candidate.id}-${rs.id}`}
                    className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300"
                  >
                    <div
                      className="h-11 w-11 my-1 cursor-pointer"
                      title={rs.name}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowResultCandidate({ candidate, roleStatusId: rs.id });
                      }}
                    >
                      {assessmentScore && assessmentScore.score !== null ? (
                        <span
                          className={`items-center justify-center h-11 w-11 inline-flex p-2 text-white text-xs font-bold rounded-full ${getColorClassBySkillScore(100 - (assessmentScore.scorePercentile ?? 0))}`}
                        >
                          {assessmentScore.score.toFixed(1)}
                        </span>
                      ) : (
                        <span className="text-xs font-bold">-</span>
                      )}
                    </div>
                  </td>
                );
              })}
              {roleId && candidate.id === showResultCandidate?.candidate.id && (
                <CandidateAssessmentResult
                  candidateId={candidate.id}
                  roleId={roleId}
                  initialRoleStatusId={showResultCandidate?.roleStatusId}
                  onClose={() => {
                    setShowResultCandidate(null)
                  }}
                />
              )}
              {skillcol === 1 &&
                uniqueSkills.map((skill, index) => {
                  const skillData = candidate.avgSkillScores.find(
                    (s) => s.skillName === skill
                  );
                  return (
                    <td
                      key={index}
                      className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300"
                    >
                      {skillData && skillData.skillScore != null ? (
                        <div className="text-sm text-gray-700 dark:text-gray-300">
                          <div
                          // className={`flex items-center justify-center h-12 w-12 rounded-full ${getColorClassBySkillScore(skillData.historicalPercentile)}`}
                          >
                            <div
                              className={`flex items-center justify-center h-10 w-10 inline-flex p-2 text-white text-xs font-bold rounded-full ${getColorClassBySkillScore(100 - skillData.skillScore)}`}
                            >
                              {skillData.skillScore != null && skillData.skillScore > 0 ? < > <span className="!text-[11px]">{skillData.skillScore.toFixed(1)}</span> <span className="text-[8px]">%</span></> : 0}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                })}
              {/* <td
              className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300"
              onMouseEnter={() => handleMouseEnter(candidate.id)}
              onMouseLeave={handleMouseLeave}
            >
              <span
                className={`relative items-center justify-center h-11 w-11  inline-flex p-2 text-white text-xs font-bold rounded-full ${getColorClassBySkillScore(candidate.scorePercentile)}`}
              >
                {candidate.score !== null ? candidate.score : "-"}
                
              </span>
            </td> */}

              {/* Grades - shown for shipping as well; it replaces the per-assessment score
                  columns there. Must stay in step with the "Grades" header's isShipping: -1. */}
              <td className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                {showGrades(candidate) ? (
                  <Grade
                    handleUpdateCandidates={handleUpdateCandidates}
                    roleStatuses={status.roleStatuses}
                    candidate={candidate}
                  />
                ) : (
                  <span className="text-xs">N/A</span>
                )}
              </td>
              {/* <td
                          )}
                      </div>
                    </>
                  ) : (
                    "-"
                  )}
                </div>
              </td>
              {skillcol === 1 &&
                uniqueSkills.map((skill, index) => {
                  const skillData = candidate.avgSkillScores.find(
                    (s) => s.skillName === skill
                  );
                  return (
                    <td
                      key={index}
                      className="whitespace-nowrap py-2 text-sm text-gray-500 dark:text-gray-300"
                    >
                      {skillData ? (
                        <div className="py-2 text-sm text-gray-700 dark:text-gray-300">
                          <div
                          // className={`flex items-center justify-center h-12 w-12 rounded-full ${getColorClassBySkillScore(skillData.historicalPercentile)}`}
                          >
                            <div
                              className={`inline-flex items-center justify-center h-12 w-12 p-2 text-white text-xs font-bold rounded-full ${getColorClassBySkillScore(skillData.percentile)}`}
                            >
                              {skillData.skillScore.toFixed(1)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  )
                })
              }
              <td className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                {showGrades(candidate) ? (
                  <Grade
                    handleUpdateCandidates={handleUpdateCandidates}
                    roleStatuses={status.roleStatuses}
                    candidate={candidate}
                  />
                ) : (
                  <span className="text-xs">N/A</span>
                )}
              </td>
              {/* <td
              className={`pl-4 whitespace-nowrap py-2 text-sm text-gray-500 dark:text-gray-300`}
            >
              {candidate.assignmentSubmission ? (
                <a
                  href={candidate.assignmentSubmission.assignmentLink}
                  target="blank"
                  className="font-medium text-entntblue hover:text-entntorange"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  GitHub
                </a>
              ) : (
                "-"
              )}
            </td> */}
              {/* <td className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
              {candidate.yearsOfExperience === 0
                ? candidate.expectedGraduationDate
                  ? dateConverter(candidate.expectedGraduationDate)
                  : 0 + " years"
                : candidate.yearsOfExperience + " years"}
            </td> */}
              {/* <td className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
              <div className="flex relative">
                <span
                  style={
                    getLastKnownPos(candidate) !== undefined
                      ? getLastKnownPos(candidate)?.type === "edu"
                        ? getStyleForUniversity(
                          getLastKnownPos(candidate)?.ranking ?? 0,
                          (getLastKnownPos(candidate)?.value as Education)
                            .postGrad
                        )
                        : getStyleForCompany(
                          getLastKnownPos(candidate)?.ranking ?? 0
                        )
                      : undefined
                  }
                  className={`px-2 py-[2px] rounded-md text-xs truncate max-w-40`}
                >
                  {getLastKnownPos(candidate) !== undefined &&
                    (getLastKnownPos(candidate)?.type === "edu"
                      ? (getLastKnownPos(candidate)?.value as Education)
                        .university.name
                      : (getLastKnownPos(candidate)?.value as Experience)
                        .companyLocation.company.name)}
                </span>
              </div>
            </td> */}
              {/* <td className="whitespace-nowrap text-sm text-gray-500">
              {getLastKnownPos(candidate) !== undefined &&
              getLastKnownPos(candidate)?.type === "edu"
                ? (getLastKnownPos(candidate)?.value as Education).period
                : getExpTime(getLastKnownPos(candidate)?.value as Experience)}
            </td> */}
              {!isShipping && (
                <td className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                  {candidate.expectedGraduationDate
                    ? dateConverter(candidate.expectedGraduationDate)
                    : (candidate.noticePeriod ?? 0) + " mon"}
                </td>
              )}
              {showRoleQGrading && (
                <td
                  className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300 pr-4 cursor-pointer"
                  title="Click to see this candidate's answers and the points each earned"
                  onClick={(e) => {
                    // The row itself has a click handler; this must not trigger it.
                    e.stopPropagation();
                    setBreakdownCandidate(candidate);
                  }}
                >
                  {candidate.applicationCategory &&
                    candidate.applicationCategory !== "NotScored" &&
                    candidate.applicationCategory in APPLICATION_CATEGORY_LABELS ? (
                    // Colour carries the category (green Good / yellow Relevant / red Not
                    // relevant), so only the score is printed to keep the column narrow. The
                    // category name stays available as a tooltip and to screen readers.
                    <span
                      className={`inline-block rounded-full px-2 py-0.5 text-xs font-semibold hover:ring-2 hover:ring-gray-300 ${APPLICATION_CATEGORY_STYLES[candidate.applicationCategory as ApplicationCategory]}`}
                      title={APPLICATION_CATEGORY_LABELS[candidate.applicationCategory as ApplicationCategory]}
                      aria-label={`${candidate.applicationScore != null ? `${Math.round(candidate.applicationScore)}%, ` : ""}${APPLICATION_CATEGORY_LABELS[candidate.applicationCategory as ApplicationCategory]}`}
                    >
                      {candidate.applicationScore != null ? `${Math.round(candidate.applicationScore)}%` : "-"}
                    </span>
                  ) : (
                    // Not scored: answered none of the weighted questions (e.g. applied before
                    // the role had them). Still clickable - the modal shows what they did answer.
                    <span className="hover:underline">-</span>
                  )}
                  {breakdownCandidate?.id === candidate.id && roleId && token && (
                    <ApplicationScoreBreakdownModal
                      roleId={roleId}
                      candidateId={candidate.id}
                      candidateName={`${candidate.firstName} ${candidate.lastName}`.trim()}
                      token={token}
                      onClose={() => setBreakdownCandidate(null)}
                    />
                  )}
                </td>
              )}
              {roleListQuestions.map((q) => {
                const answer =
                  (candidateRoleAnswersBulk?.[candidate.id] ?? {})[q.id];
                const value =
                  (answer?.value ??
                    answer?.answerText ??
                    (answer?.valueNumber != null
                      ? String(answer.valueNumber)
                      : ""))
                    .toString();
                return (
                  <td
                    key={`roleq-${candidate.id}-${q.id}`}
                    className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-300 max-w-[160px] truncate"
                    title={value || "-"}
                  >
                    {value || "-"}
                  </td>
                );
              })}
              {/* <td className="whitespace-nowrap text-sm text-gray-500">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {candidate.candidateStatuses[
                  candidate.candidateStatuses.length - 1
                ]?.date &&
                  dateConverter(
                    candidate.candidateStatuses[
                      candidate.candidateStatuses.length - 1
                    ].date
                  )}
              </p>
            </td> */}
            </tr >
            {clickedRow && clickedRow === candidate.id &&
              <tr>
                <td colSpan={1000} >
                  <div className="bg-gray-200 dark:bg-gray-900 mx-auto shadow-inner">
                    <div className="dark:text-gray-100 font-medium text-sm w-full grid grid-cols-4">
                      <span className="px-6 py-3">Company Name</span>
                      <span className="px-6 py-3">Job Title/Rank</span>
                      <span className="px-6 py-3">Type</span>
                      <span className="px-6 py-3">Period</span>
                    </div>
                    {
                      isOpenDetailExp && isOpenDetailExp.map((exp) => {
                        return (
                          <div className="text-gray-500 dark:text-gray-300 text-sm w-full grid grid-cols-4">
                            <span className="px-6 py-3">{exp.companyName}</span>
                            <span className="px-6 py-3">{exp.title}{exp.rank}</span>
                            <span className="px-6 py-3">{exp.isOnboard ? "OnBoard" : "Ashore"}</span>
                            <span className="px-6 py-3">{exp.period}</span>
                          </div>
                        )
                      })
                    }
                  </div>
                </td>
              </tr>
            }
          </Fragment>
        ))
        }
      </tbody >
      {isCVViewerOpen && role && (
        <CVViewerModal
          isOpen={isCVViewerOpen}
          onClose={closeCVViewer}
          candidates={candidates}
          initialCandidateIndex={cvViewerCandidateIndex}
          role={role}
          onGradeUpdate={handleUpdateCandidates}
        />
      )}

    </>
  );
}
